// extracted by mini-css-extract-plugin
export default {"fetching":"fetching_fetching"};